import {
  call,
  delay,
  put,
  race,
  SagaReturnType,
  takeLeading,
} from 'redux-saga/effects';
import { omit } from 'ramda';
import Action from '../../actions';
import { setCommonConfiguration } from '../../actions/app/configuration';
import { getCommonConfiguration } from '../api/index';

import { FETCH_CONFIGURATION_REQUEST } from '../../constants/configuration';

export const DELAY_TIMEOUT = 30000;

export function* fetchConfigurationWorker() {
  try {
    const {
      response: commonConfig,
      timeout,
    }: {
      response: SagaReturnType<typeof getCommonConfiguration>;
      timeout: boolean;
    } = yield race({
      response: call(getCommonConfiguration),
      timeout: delay(DELAY_TIMEOUT),
    });

    if (timeout) {
      return yield put(Action.fetchConfigurationFailByTimeout());
    }

    yield put(
      setCommonConfiguration(
        omit(
          // TODO check if we need this code. maybe set config directly
          // @ts-ignore
          ['brand'],
          commonConfig
        )
      )
    );
    yield put(Action.setIsConfigurationLoaded(true));
  } catch (e) {
    yield put(Action.fetchConfigurationFail(e));
  }
}

export function* fetch() {
  yield takeLeading(FETCH_CONFIGURATION_REQUEST, fetchConfigurationWorker);
}
